<style scoped lang="less">
ul {
    list-style-type: disc;
}
</style>
<template>
    <div class="modal-content" ref="container">
        <div class="modal-header">
            <h2 class="modal-title">Validation Issues</h2>
            <button type="button" class="close" @click="goToPageFirstErrorFunc()" autofocus aria-label="Close"><span class="icon icon-close" aria-hidden="true"></span></button>
        </div>
        <div class="modal-body" describedby-text>
            <p>Form is not ready to submit.</p>
            <p v-if="pageGroups[0].pages.length == 1">
                Please correct the
                <!-- Add sr only copy since the original link is intently hidden to announce it only on focus -->
                <span class="sr-only">validation issues</span>
                <span aria-hidden="true">
                    <a href="#" @click.prevent="goToPageFirstErrorFunc()">
                        validation issues
                        <span class="sr-only">
                            &comma;
                            <Promised :pending-delay="null" :promise="pageErrors[0]" #combined="{ data }">
                                <!-- Add comma with whitespaces to properly emphasize each error by pause -->
                                <span>{{ (data || []).join(" , ") }}</span>
                            </Promised>
                        </span>
                    </a>
                </span>
                on the form.
            </p>
            <template v-else>
                <p>Please select a page to navigate to its first invalid field:</p>
                <ul>
                    <li v-for="(page, index) in invalidPages">
                        <a href="#" @click.prevent="goToPageFirstErrorFunc(page)">
                            {{ page.definition.settings.label }}
                            <span class="sr-only">
                                Errors:
                                <Promised :pending-delay="null" :promise="pageErrors[index]" #combined="{ data }">
                                    <!-- Add comma with whitespaces to properly emphasize each error by pause -->
                                    <span>{{ (data || []).join(" , ") }}</span>
                                </Promised>
                            </span>
                        </a>
                    </li>
                </ul>
            </template>
        </div>
    </div>
</template>
<script lang="ts">
import { computed, defineComponent, ref, SetupContext } from "vue";
import { dialogSetup, DialogProps } from "@/lib/dialogMixin.3";
import { Promised } from "@/lib/Promised";
import type PageDef from "../elements/PageDef";
type Props = {
    pageGroups: { pages: PageDef[] }[];
    goToPageFirstError: (page?: PageDef) => void;
} & DialogProps;
export default defineComponent({
    components: { Promised },
    props: ["pageGroups", "goToPageFirstError", "triggerElement"],
    setup(props: Props, context: SetupContext) {
        const containerRef = ref<HTMLElement>(null!);
        dialogSetup(containerRef, props);
        const invalidPages = computed(() => {
            return (props.pageGroups[0].pages || []).filter(page => page.status == "Invalid");
        });
        const pageErrors = computed(() => {
            return invalidPages.value.map(page => page.descendentsErrors());
        });
        const goToPageFirstErrorFunc = async (page?: PageDef) => {
            context.emit("close");
            props.goToPageFirstError(page);
        };

        return {
            container: containerRef,
            invalidPages,
            pageErrors,
            goToPageFirstErrorFunc,
        };
    },
});
</script>
